import styled from 'styled-components';

type CustomChannelIcon = { label: string; icon: () => JSX.Element; value: string };

import {
  BRANDS_ICONS,
  GENERIC_ICON,
  getChannelIconsDropdownOptions,
} from '@ad-scripts/presentation/components/common/custom_channels';
import { default as ADAsyncDropdownMenu } from '@ad-scripts/presentation/components/common/async_dropdown_menu';
import { default as ADButton, ButtonTypes, OutlineButtonBase } from '@ad-scripts/presentation/components/common/button';
import { default as ADCheckbox } from '@ad-scripts/presentation/components/common/checkbox';
import { default as ADClickToEditField } from '@ad-scripts/presentation/components/common/click_to_edit_field';
import { default as ADCollapsed } from '@ad-scripts/presentation/components/common/collapse';
import { default as ADCustomSwitch } from '@ad-scripts/presentation/components/common/custom_switch';
import { default as ADDropdownMenu } from '@ad-scripts/presentation/components/common/dropdown_menu';
import { default as ADEditableField } from '@ad-scripts/presentation/components/lib/editable_field_dumb';
import { default as ADFullPageModal } from '@ad-scripts/presentation/components/common/full_page_modal';
import { default as ADFullPageSpinner } from '@ad-scripts/presentation/components/common/full_page_spinner';
import { default as ADInput } from '@ad-scripts/presentation/components/common/input';
import { default as ADInputField, InputActionButton } from '@ad-scripts/presentation/components/common/input_field';
import {
  default as ADInputWithTimeConvertField,
  TimeUnits,
} from '@ad-scripts/presentation/components/common/input_with_time_convert_field';
import { default as ADMultiselectChips } from '@ad-scripts/presentation/components/common/multiselect_chips';
import { default as ADMultiSelectDropdownMenu } from '@ad-scripts/presentation/components/common/multi_select_dropdown_menu';
import { default as ADMultiSelect } from '@ad-scripts/presentation/components/common/multiSelect';
import { default as ADOutsideClickHandler } from '@ad-scripts/presentation/components/common/utilities/outside_click_handler';
import { default as ADPortalModalWrapper } from '@ad-scripts/presentation/components/lib/portal_modal_wrapper';
import { default as ADSearchInput } from '@ad-scripts/presentation/components/common/search_input';
import { default as ADTextareaField } from '@ad-scripts/presentation/components/common/textarea_field';
import { default as ADToast, ToastPortalDeprecated } from '@ad-scripts/presentation/components/common/toast_deprecated';
import { default as ADToggle } from '@ad-scripts/presentation/components/common/toggle';
import { default as ADTooltip } from '@ad-scripts/presentation/components/common/tooltip';
import { CloseButtonTypes as ADCloseButtonTypes } from '@ad-scripts/presentation/components/common/button';
import { ControlLabel, ControlDescription } from '@ad-scripts/presentation/components/common/forms/control_container';
import { default as ADTextEditor } from '@ad-scripts/presentation/components/text_editor_new';
import { default as EmojiCore } from '@ad-scripts/presentation/components/text_editor_new/components/controls/emoji_new';

import BasicToast from '@ad-scripts/presentation/components/toasts/toast_content/basic_toast';
import ToastsPortal from '@ad-scripts/presentation/components/toasts/toasts_portal';
import { default as ADPortal } from '@ad-scripts/presentation/components/common/utilities/portal';

enum CloseButtonTypes {
  BACK_BUTTON = ADCloseButtonTypes.BACK_BUTTON,
  NONE = ADCloseButtonTypes.NONE,
  X_ICON = ADCloseButtonTypes.X_ICON,
}

// https://github.com/Microsoft/TypeScript/issues/14558 :(
const AsyncDropdownMenu: any = ADAsyncDropdownMenu;
const Button: any = ADButton;
const Checkbox: any = ADCheckbox;
const ClickToEditField: any = ADClickToEditField;
const Collapsed: any = ADCollapsed;
const CustomSwitch: typeof ADCustomSwitch = ADCustomSwitch;
const DropdownMenu: any = ADDropdownMenu;
const EditableField: any = ADEditableField;
const FullPageModal: any = ADFullPageModal;
const FullPageSpinner: any = ADFullPageSpinner;
const Input: any = ADInput;
const InputField: any = ADInputField;
const InputWithTimeConvertField: any = ADInputWithTimeConvertField;
const MultiselectChips: any = ADMultiselectChips;
const MultiSelect: any = ADMultiSelect;
const MultiSelectDropdownMenu: any = ADMultiSelectDropdownMenu;
const OutsideClickHandler: any = ADOutsideClickHandler;
const PortalModalWrapper: any = ADPortalModalWrapper;
const SearchInput: any = ADSearchInput;
const TextareaField: any = ADTextareaField;
const TextEditor: any = ADTextEditor;
const Toast: any = ADToast;
const Toggle: any = ADToggle;
const Tooltip: any = ADTooltip;
const Emoji: any = EmojiCore;

const Portal: any = ADPortal;

const CUSTOM_CHANNEL_ICONS: {
  BRANDS_ICONS: CustomChannelIcon[];
  GENERIC_ICON: CustomChannelIcon;
  getChannelIconsDropdownOptions;
} = {
  BRANDS_ICONS,
  GENERIC_ICON,
  getChannelIconsDropdownOptions,
};

const OutlineButton = styled(Button)`
  ${OutlineButtonBase};
  color: ${p => p.theme.colors.black};
  border-color: ${p => p.theme.colors.gray300};
`;

export {
  AsyncDropdownMenu,
  Button,
  ButtonTypes,
  Checkbox,
  ClickToEditField,
  CloseButtonTypes,
  Collapsed,
  ControlDescription,
  ControlLabel,
  CUSTOM_CHANNEL_ICONS,
  CustomSwitch,
  DropdownMenu,
  EditableField,
  FullPageModal,
  FullPageSpinner,
  Input,
  InputActionButton,
  InputField,
  InputWithTimeConvertField,
  MultiSelect,
  MultiselectChips,
  MultiSelectDropdownMenu,
  OutlineButton,
  OutsideClickHandler,
  PortalModalWrapper,
  SearchInput,
  TextareaField,
  TextEditor,
  TimeUnits,
  Toast,
  ToastPortalDeprecated,
  Toggle,
  Tooltip,
  Emoji,
  BasicToast,
  ToastsPortal,
  Portal,
};
